<template>
  <div class="moon-dashboard">
    <!-- Header Section -->
    <section class="dashboard-header">
      
      <div class="header-content">
          <!-- 🔥 Logout Button -->
      <div class="logout-box" @click="logout">
        <img src="/media/svg/moon-assets/logout.svg" class="logout-icon" alt="logout" />
        <span>Logout</span>
      </div>
        <div class="welcome-text">
          <h1>Welcome, {{ userName }}</h1>
          <p>Performance Overview</p>
        </div>

        <div class="stats-box">
          <div class="stat-item">
            <div class="stat-value">{{ currentOrders }}</div>
            <div class="stat-label">Total Orders</div>
          </div>
          <div class="stat-item">
            <div class="stat-value">AED {{ currentPayout.toLocaleString() }}</div>
            <div class="stat-label">Total Payout</div>
          </div>
        </div>
      </div>
     
    </section>

    <!-- Content Section -->
    <section class="dashboard-content">
      <div class="tabs">
        <button
          v-for="tab in tabs"
          :key="tab"
          :class="{ active: activeTab === tab }"
          @click="activeTab = tab"
        >
          {{ tab }}
        </button>
      </div>

      <!-- My Coupons Tab -->
      <div v-if="activeTab === 'My Coupons'" class="coupon-table">
        <table>
          <thead>
            <tr>
              <th>Advertiser</th>
              <th>Coupon</th>
              <th>Industry</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="coupon in paginatedCoupons" :key="coupon.id">
              <td>{{ coupon.company_name || '-' }}</td>
              <td>{{ coupon.coupon_code || '-' }}</td>
              <td>{{ coupon.Industry || '-' }}</td>
              <td>
                <span
                  class="status-dot"
                  :class="{ active: coupon.coupon_status === 'Active' }"
                ></span>
                {{ coupon.coupon_status }}
              </td>
            </tr>
          </tbody>
        </table>
<!-- PAGINATION -->
<div v-if="totalPages > 1" class="pagination">
  <button 
    :disabled="currentPage === 1"
    @click="currentPage--"
  >
    Prev
  </button>

  <span>Page {{ currentPage }} of {{ totalPages }}</span>

  <button 
    :disabled="currentPage === totalPages"
    @click="currentPage++"
  >
    Next
  </button>
</div>

        <div v-if="!couponsData.length" class="no-coupons">
          No coupons available
        </div>
      </div>

<!-- 🆕 Orders Tab -->
<div v-if="activeTab === 'Orders'" class="details-table">
        <div class="date-filter">
          <label>📅 Date Range:</label>
          <input type="date" v-model="detailsFilter.from" />
          <span>to</span>
          <input type="date" v-model="detailsFilter.to" />
          <button @click="fetchDetails">Filter</button>
        </div>

        <table>
          <thead>
            <tr>
              <th>Advertiser</th>
              <th>Coupon Code</th>
              <th>Revenue (AED)</th>
              <th>Payout (AED)</th>
              <th>Country</th>
              <th>Customer Type</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in paginatedDetails" :key="index">
              <td>{{ item.advertiser }}</td>
              <td>{{ item.coupon_code }}</td>
              <td>{{ item.revenu }}</td>
              <td>{{ item.payout }}</td>
              <td>{{ item.country }}</td>
              <td>{{ item.customer_type }}</td>
              <td>{{ item.time }}</td>
            </tr>
          </tbody>
        </table>

        <div v-if="!detailsData.length" class="no-data">No details available</div>

        <div v-if="detailsTotalPages > 1" class="pagination">
          <button :disabled="detailsPage === 1" @click="detailsPage--">Prev</button>
          <span>Page {{ detailsPage }} of {{ detailsTotalPages }}</span>
          <button :disabled="detailsPage === detailsTotalPages" @click="detailsPage++">Next</button>
        </div>
      </div>

      <!-- Overview (Summary) Tab -->
      <div v-if="activeTab === 'Overview'" class="summary-table">
        <!-- 🗓️ Date Filter Bar -->
        <div class="date-filter">
          <label>📅 Date Range:</label>
          <input type="date" v-model="filters.from" />
          <span>to</span>
          <input type="date" v-model="filters.to" />
          <button @click="applyDateFilter">Filter</button>
          <span class="current-label">(Default: Current Month)</span>
        </div>

        <table>
          <thead>
            <tr>
              <th>Advertiser</th>
              <th>Coupon</th>
              <th>Revenue [AED]</th>
              <th>Conversions</th>
              <th>Payout [AED]</th>
            </tr>
          </thead>

          <tbody>
            <!-- Parent Rows -->
            <template v-for="(group, index) in groupedSummary">
              <tr
                class="main-row"
                :key="'main-' + index"
                @click="toggleExpand(group.client_name)"
              >
                <td class="advertiser">
                  <span class="toggle-icon">
                    {{ expanded[group.client_name] ? '▼' : '▶' }}
                  </span>
                  <img
                    v-if="group.logo"
                    :src="group.logo"
                    class="brand-logo"
                    alt="logo"
                  />
                  {{ group.client_name }}
                </td>
                <td>—</td>
                <td>AED {{ group.totalRevenue.toLocaleString() }}</td>
                <td>{{ group.totalConversions }}</td>
                <td>AED {{ group.totalPayout.toLocaleString() }}</td>
              </tr>

              <!-- Child Rows -->
              <tr
                v-for="(item, i) in group.items"
                :key="'child-' + group.client_name + '-' + i"
                v-show="expanded[group.client_name]"
                class="child-row"
              >
                <td></td>
                <td>{{ item.coupon_code }}</td>
                <td>AED {{ item.net_revenue_aed.toLocaleString() }}</td>
                <td>{{ item.conversions }}</td>
                <td>AED {{ item.net_payout_aed.toLocaleString() }}</td>
              </tr>
            </template>
          </tbody>
        </table>

        <div v-if="!groupedSummary.length" class="no-data">
          No data available
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ApiService from "../../core/services/api.service";

export default {
  name: "CustomDashboard",
  data() {
    function formatDate(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    }
    const today = new Date();
    const start = formatDate(new Date(today.getFullYear(), today.getMonth(), 1));
    const end = formatDate(new Date(today.getFullYear(), today.getMonth() + 1, 0));

    return {
      userName: localStorage.getItem("username"),
      currentOrders: 0,
      currentPayout: 0,
      couponsData: [],
      groupedSummary: [],
      expanded: {},
      activeTab: "Overview",
      tabs: ["Overview", "Orders", "My Coupons"],
      filters: { from: start, to: end },
      currentPage: 1,
      perPage: 10,
      detailsPage: 1,
      detailsPerPage: 10,
      detailsData: [],
      detailsFilter: { from: start, to: end },
    };
  },
  computed: {
    paginatedCoupons() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.couponsData.slice(start, start + this.perPage);
    },
    totalPages() {
      return Math.ceil(this.couponsData.length / this.perPage);
    },
    paginatedDetails() {
      const start = (this.detailsPage - 1) * this.detailsPerPage;
      return this.detailsData.slice(start, start + this.detailsPerPage);
    },
    detailsTotalPages() {
      return Math.ceil(this.detailsData.length / this.detailsPerPage);
    },
  },
  mounted() {
    this.fetchSummary();
  },
  watch: {
    activeTab(newVal) {
      if (newVal === "My Coupons") this.fetchCoupons();
      if (newVal === "Orders") this.fetchDetails();
    },
  },
  methods: {
    async fetchCoupons() {
      try {
        const payload = { contact_id: localStorage.getItem("contact_id") };
        const response = await ApiService.post("/active-coupons", payload);
        this.couponsData = response.data?.data?.coupon || [];
      } catch {
        this.couponsData = [];
      }
    },
    async fetchSummary() {
      try {
        const payload = {
          contact_id: localStorage.getItem("contact_id"),
          datefrom: this.filters.from,
          dateto: this.filters.to,
        };
        const response = await ApiService.post("/v3/stats", payload);
        const raw = response.data?.data?.listing_data?.conversions || [];
        this.groupedSummary = this.groupByAdvertiser(raw);
        this.updateMonthlyStats(raw);
      } catch {
        this.groupedSummary = [];
      }
    },
    async fetchDetails() {
      try {
        const payload = {
          contact_id: localStorage.getItem("contact_id"),
          datefrom: this.detailsFilter.from,
          dateto: this.detailsFilter.to,
        };
        const response = await ApiService.post("/v2/order-details", payload);
        this.detailsData = response.data?.data?.All_Conversions || [];
      } catch {
        this.detailsData = [];
      }
    },
    logout() {
      localStorage.clear();
      this.$router.push("/dashboard/login");
    },
    groupByAdvertiser(data) {
      const grouped = {};
      data.forEach((item) => {
        const name = item.client_name || "Unknown Advertiser";
        if (!grouped[name]) {
          grouped[name] = {
            client_name: name,
            logo: item.logo,
            items: [],
            totalRevenue: 0,
            totalConversions: 0,
            totalPayout: 0,
          };
        }
        grouped[name].items.push(item);
        grouped[name].totalRevenue += item.net_revenue_aed || 0;
        grouped[name].totalConversions += item.conversions || 0;
        grouped[name].totalPayout += item.net_payout_aed || 0;
      });
      return Object.values(grouped);
    },
    updateMonthlyStats(data) {
      this.currentOrders = data.reduce((s, i) => s + (i.conversions || 0), 0);
      this.currentPayout = data.reduce((s, i) => s + (i.net_payout_aed || 0), 0);
    },
    toggleExpand(name) {
      this.$set(this.expanded, name, !this.expanded[name]);
    },
    applyDateFilter() {
      if (!this.filters.from || !this.filters.to) {
        alert("Select valid date range");
        return;
      }
      this.fetchSummary();
    },
  },
};
</script>

<style scoped>
/* 🌙 Moon Dashboard Base */
.moon-dashboard {
  background-color: #f6f7fb;
  min-height: 100vh;
  font-family: "Inter", sans-serif;
  color: #1a1a40;
}

/* HEADER */
.dashboard-header {
  background-color: #e9e5ff;
  color: #1a1a40;
  padding: 3rem 5%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.05);
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  /* max-width: 1100px; */
}
/* container that holds the 3 columns */
.dashboard-header .header-content {
  margin: 0 auto;         /* center the whole header block on page */
  width: 100%;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important; /* left | center (flex:1) | right */
  gap: 16px;
  padding: 0 20px;        /* optional inner padding */
  box-sizing: border-box;
}

/* left column - logout */
.dashboard-header .logout-box {
  flex: 0 0 auto;         /* keep logout compact at left */
  display: flex;
  align-items: center;
  gap: 8px;
}

/* middle column - welcome text */
.dashboard-header .welcome-text {
  flex: 1 1 auto;         /* take remaining space */
  display: flex;
  flex-direction: column;
  align-items: flex-start;   /* important: left align the content */
  justify-content: center;
  text-align: left;          /* left align text */
  padding-left: 8px;         /* small spacing from logout */
}

/* right column - stats */
.dashboard-header .stats-box {
  flex: 0 0 auto;         /* keep stats compact at right */
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: flex-end;
}

/* style for each stat card to keep layout consistent */
.dashboard-header .stats-box .stat-item {
  min-width: 140px;       /* adjust to match your card width */
  display: flex;
  flex-direction: column;
  align-items: center;
}

.welcome-text h1 {
  font-size: 1.9rem;
  font-weight: 700;
  margin: 0;
  color: #2c1d73;
}

.welcome-text p {
  margin: 0.25rem 0 0;
  font-size: 1rem;
  color: #5f5f8d;
}

/* STATS BOX */
.stats-box {
  display: flex;
  gap: 1.5rem;
}

.stat-item {
  background-color: #fff;
  color: #2c1d73;
  border-radius: 12px;
  padding: 1rem 1.8rem;
  text-align: center;
  min-width: 160px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
}

.stat-value {
  font-size: 1.6rem;
  font-weight: 700;
}

.stat-label {
  font-size: 0.9rem;
  color: #555;
}

/* CONTENT WRAPPER */
.dashboard-content {
  background-color: #fff;
  width: 90%;
  margin: -2rem auto 2rem;
  border-radius: 12px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.06);
  padding: 2.5rem;
  position: relative;
}

/* TABS */
.tabs {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
  padding-bottom: 15px;
}

.tabs button {
  padding: 0.6rem 1.6rem;
  border: 1px solid #cfcff6;
  background: #f9f9ff;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  font-size: 0.95rem;
  color: #2c1d73;
  transition: 0.3s ease;
}

.tabs button:hover {
  background: #e9e5ff;
}

.tabs button.active {
  background: #2c1d73;
  color: #fff;
  border-color: #2c1d73;
}

/* DATE FILTER */
.date-filter {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin-bottom: 1.2rem;
  font-weight: 500;
  color: #2c1d73;
}

.date-filter input {
  padding: 0.45rem 0.7rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 0.9rem;
}

.date-filter button {
  background: #2c1d73;
  color: white;
  border: none;
  padding: 0.55rem 1.1rem;
  border-radius: 6px;
  cursor: pointer;
  transition: 0.2s;
}

.date-filter button:hover {
  background: #4b35c4;
}

.current-label {
  font-size: 0.85rem;
  color: #777;
}

/* TABLE RESET */
.summary-table table,
.coupon-table table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 10px;
  overflow: hidden;
  margin-top: 1rem;
}
.pagination {
  margin-top: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}

.pagination button {
  background: #2c1d73;
  color: white;
  border: none;
  padding: 0.45rem 1rem;
  font-size: 0.9rem;
  border-radius: 6px;
  cursor: pointer;
  transition: 0.2s;
}

.pagination button:disabled {
  background: #bfbfda;
  cursor: not-allowed;
}

.pagination span {
  color: #2c1d73;
  font-weight: 600;
}

/* TABLE HEADERS */
.summary-table th,
.coupon-table th {
  background-color: #f3f1ff;
  padding: 14px 20px;
  font-size: 0.9rem;
  font-weight: 600;
  color: #2c1d73;
  text-align: left;
  letter-spacing: 0.4px;
}

/* TABLE CELLS */
.summary-table td,
.coupon-table td {
  padding: 14px 20px;
  border-top: 1px solid #eee;
  font-size: 0.95rem;
  color: #3c3c5b;
  vertical-align: middle;
}

/* TABLE ROW HOVER */
.summary-table tr:hover.main-row {
  background-color: #f9f9ff;
  cursor: pointer;
}

/* SUMMARY PARENT ROW */
.main-row {
  background-color: #fdfcff;
  font-weight: 600;
  transition: 0.2s;
}

/* EXPANDED CHILD ROWS */
.child-row {
  background: #fff;
}

.child-row td {
  border-top: 1px solid #f2f2f2;
  color: #5a5a7c;
}

/* ADVERTISER CELL */
.advertiser {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* LOGO */
.brand-logo {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  object-fit: cover;
  background-color: #f2f2f2;
  margin-right: 10px;
}

/* EXPAND/COLLAPSE */
.toggle-icon {
  font-weight: 700;
  margin-right: 6px;
  color: #2c1d73;
}

/* STATUS DOT */
.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 6px;
  background-color: #bbb;
}

.status-dot.active {
  background-color: #4cd964;
}

/* NO DATA */
.no-coupons,
.no-data {
  text-align: center;
  padding: 1.5rem;
  color: #888;
  font-size: 1rem;
}
.logout-box {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #ffffff;
  padding: 10px 16px;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  color: #2c1d73;
  font-weight: 600;
  transition: 0.2s;
}

.logout-box:hover {
  background: #f4f1ff;
}

.logout-icon {
  width: 20px;
  height: 20px;
}
.details-table table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
}
.details-table th {
  background-color: #f3f1ff;
  padding: 14px 20px;
  color: #2c1d73;
  text-align: left;
  font-weight: 600;
}
.details-table td {
  padding: 14px 20px;
  border-top: 1px solid #eee;
  color: #3c3c5b;
}
.details-table tr:hover {
  background-color: #fafaff;
}
</style>

